export const PHONE_SMALL = 320;
export const PHONE_MEDIUM = 375;
export const PHONE_LARGE = 425;
export const TABLET = 768;
export const DESKTOP = 1024;
export const DESKTOP_LARGE = 1440;
export const FOUR_K = 2560;
